import {
    GET_USER_CAN_MAKE_APPLICATION,
    GET_USER_CAN_MAKE_APPLICATION_SUCCESS,
    GET_USER_CAN_APPROVE_AGREEMENT,
    GET_USER_CAN_APPROVE_AGREEMENT_SUCCESS,
    GET_USERS_MERCHANT_APPLICATION,
    GET_USERS_MERCHANT_APPLICATION_SUCCESS,
    ADD_MERCHANT_APPLICATION,
    ADD_MERCHANT_APPLICATION_SUCCESS,
    MERCHANT_APPLICATION_API_ERROR,
    APPROVE_MERCHANT_AGREEMENT_SUCCESS,
    APPROVE_MERCHANT_AGREEMENT,
    UPLOAD_MERCHANT_FILE,
    UPLOAD_MERCHANT_FILE_SUCCESS,
    DELETE_MERCHANT_FILE,
    DELETE_MERCHANT_FILE_SUCCESS,
    UPLOAD_MERCHANT_FILE_LIST,
    UPLOAD_MERCHANT_FILE_LIST_SUCCESS,
    GET_MERCHANT_APPLICATION_DOCUMENT,
    GET_MERCHANT_APPLICATION_DOCUMENT_SUCCESS,
    GET_MERCHANT_APPLICATION_DOCUMENT_FILE_SUCCESS,
    GET_MERCHANT_APPLICATION_DOCUMENT_FILE
  } from "./actionTypes"
  
  export const getUsersMerchantApplication = record => ({
    type: GET_USERS_MERCHANT_APPLICATION,
    payload: record,
  })

  export const getUsersMerchantApplicationSuccess = record => ({
    type: GET_USERS_MERCHANT_APPLICATION_SUCCESS,
    payload: record,
  })

  export const getUserCanMakeApplication = record => ({
    type: GET_USER_CAN_MAKE_APPLICATION,
    payload: record,
  })  
  export const getUserCanMakeApplicationSuccess = UserCanMakeApplicationResponseVm => ({
    type: GET_USER_CAN_MAKE_APPLICATION_SUCCESS,
    payload: UserCanMakeApplicationResponseVm,
  })  

  export const getUserCanApproveAgreement = record => ({
    type: GET_USER_CAN_APPROVE_AGREEMENT,
    payload: record,
  })  
  export const getUserCanApproveAgreementSuccess = UserCanApproveAgreementResponseVm => ({
    type: GET_USER_CAN_APPROVE_AGREEMENT_SUCCESS,
    payload: UserCanApproveAgreementResponseVm,
  })  

  export const approveMerchantAgreement = record => ({
    type: APPROVE_MERCHANT_AGREEMENT,
    payload: record,
  })  
  export const approveMerchantAgreementSuccess = record => ({
    type: APPROVE_MERCHANT_AGREEMENT_SUCCESS,
    payload: record,
  })  
  
  export const addMerchantApplication = record => ({
    type: ADD_MERCHANT_APPLICATION,
    payload: record,
  })
  
  export const addMerchantApplicationSuccess = record => ({
    type: ADD_MERCHANT_APPLICATION_SUCCESS,
    payload: record,
  })

  export const merchantApplicationApiError = error => {
    return {
      type: MERCHANT_APPLICATION_API_ERROR,
      payload: error,
    }
  }
  export const UploadMerchantFile = file => ({
    type: UPLOAD_MERCHANT_FILE,
    payload: file,
  })

  export const uploadMerchantFileSuccess = file => ({
    type: UPLOAD_MERCHANT_FILE_SUCCESS,
    payload: file,
  })

  export const UploadMerchantFileList = file => ({
    type: UPLOAD_MERCHANT_FILE_LIST,
    payload: file,
  })

  export const uploadMerchantFileListSuccess = file => ({
    type: UPLOAD_MERCHANT_FILE_LIST_SUCCESS,
    payload: file,
  })

  export const deleteMerchantFile = file => ({
    type: DELETE_MERCHANT_FILE,
    payload: file,
  })

  export const deleteMerchantFileSuccess = file => ({
    type: DELETE_MERCHANT_FILE_SUCCESS,
    payload: file,
  })

  export const getApplicationDocumentByGuid = guid => ({
    type: GET_MERCHANT_APPLICATION_DOCUMENT,
    payload: guid,
  })

  export const getApplicationDocumentByGuidSuccess = guid => ({
    type: GET_MERCHANT_APPLICATION_DOCUMENT_SUCCESS,
    payload: guid,
  })

  export const getMerchantFileView = subMerchantId => ({
    type: GET_MERCHANT_APPLICATION_DOCUMENT_FILE,
    payload: subMerchantId,
  })
  
  export const getMerchantFileViewSuccess = subMerchantId => ({
    type: GET_MERCHANT_APPLICATION_DOCUMENT_FILE_SUCCESS,
    payload: subMerchantId,
  })
  